import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CompanyForm from '../../../components/masters/company/CompanyForm';
import CompanyTable from '../../../components/masters/company/CompanyTable';
import { addCompany, updateCompany, clearCompanyEdit } from '../../../redux/actions/masters/company/companyAction';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .company-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .company-form, .company-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const CompanyPage = () => {
  const dispatch = useDispatch();
  const { editingCompany } = useSelector((state) => state.company);
  const users = useSelector((state) => state.users.list);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = (form) => {
    if (editingCompany && editingCompany.company_id) {
      dispatch(updateCompany({ id: editingCompany.company_id, company: form }))
        .then(() => setFormSuccess('Company updated successfully!'))
        .catch((err) => setFormError(err?.message || 'Update failed.'));
    } else {
      dispatch(addCompany(form))
        .then(() => setFormSuccess('Company added successfully!'))
        .catch((err) => setFormError(err?.message || 'Add failed.'));
    }
  };

  const handleCancel = () => {
    dispatch(clearCompanyEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="company-flex">
        <div style={tableContainer} className="company-table">
          <CompanyTable onNew={handleFormReset} />
        </div>
        <div style={formContainer} className="company-form">
          <CompanyForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingCompany={editingCompany}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            users={users}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyPage; 